import { Backdrop, useTheme } from '@mui/material'
import React from 'react'
import useStyle from './style'
import {RingLoader} from 'react-spinners'
const Loader = ({isLoader}) => {
    const theme = useTheme()
    const classes = useStyle()
  return (
    <Backdrop  sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}  open={isLoader}>
    <div className={classes.root}>
        <RingLoader  color="#A06EE1" />
    </div>
    </Backdrop>
  
  )
}
export default Loader